/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiJobTaggerUniqueFieldFromJSON, ApiJobTaggerUniqueFieldToJSON, } from './ApiJobTaggerUniqueField';
export function ApiJobTaggerSimplifiedFromJSON(json) {
    return ApiJobTaggerSimplifiedFromJSONTyped(json, false);
}
export function ApiJobTaggerSimplifiedFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'categorySelector': !exists(json, 'categorySelector') ? undefined : json['categorySelector'],
        'contractTypeSelector': !exists(json, 'contractTypeSelector') ? undefined : json['contractTypeSelector'],
        'descriptionSelector': !exists(json, 'descriptionSelector') ? undefined : json['descriptionSelector'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'idSelector': !exists(json, 'idSelector') ? undefined : json['idSelector'],
        'locationId': !exists(json, 'locationId') ? undefined : json['locationId'],
        'locationSelector': !exists(json, 'locationSelector') ? undefined : json['locationSelector'],
        'projectId': !exists(json, 'projectId') ? undefined : json['projectId'],
        'salaryRangeSelector': !exists(json, 'salaryRangeSelector') ? undefined : json['salaryRangeSelector'],
        'titleSelector': !exists(json, 'titleSelector') ? undefined : json['titleSelector'],
        'uniqueField': !exists(json, 'uniqueField') ? undefined : ApiJobTaggerUniqueFieldFromJSON(json['uniqueField']),
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (new Date(json['updatedAt'])),
    };
}
export function ApiJobTaggerSimplifiedToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'categorySelector': value.categorySelector,
        'contractTypeSelector': value.contractTypeSelector,
        'descriptionSelector': value.descriptionSelector,
        'id': value.id,
        'idSelector': value.idSelector,
        'locationId': value.locationId,
        'locationSelector': value.locationSelector,
        'projectId': value.projectId,
        'salaryRangeSelector': value.salaryRangeSelector,
        'titleSelector': value.titleSelector,
        'uniqueField': ApiJobTaggerUniqueFieldToJSON(value.uniqueField),
        'updatedAt': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
    };
}
